module.exports = __webpack_public_path__ + "img/u4.a40c4f0d.svg";